import axios from 'axios';

axios.defaults.withCredentials = true;

export function getDeptMemberList(host, qzId, params = {}) {
    return axios.get(`${host}/cooperation/rest/v1/candidate/${qzId}/members`, { params })
}

export function getGroupMemberList(host, qzId, groupId, params = {}) {
    return axios.get(`${host}/cooperation/rest/v1/candidate/${qzId}/group/${groupId}/members`, { params })
}

export function getTeamMemberList(host, qzId, teamId, params = {}) {
    return axios.get(`${host}/cooperation/rest/v1/candidate/${qzId}/team/${teamId}/members`, { params })
}

export function getRoleMemberList(host, tenantId, qzId, roleId, params = {}) {
    return axios.get(`${host}/cooperation/rest/v1/candidate/${tenantId}/role/${qzId}/${roleId}/users`, { params });
}

export function getMemberList(host, qzId, params = {}) {
    return axios.get(`${host}/cooperation/rest/v1/candidate/${qzId}/members`, { params });
}``

export function getDeptList(host, qzId, params) {
    return axios.get(`${host}/cooperation/rest/v1/candidate/${qzId}/depts`, { params });
}

export function getGroupList(host, qzId, params) {
    return axios.get(`${host}/cooperation/rest/v1/candidate/${qzId}/groups`, { params });
}

export function getTeamList(host, qzId, params) {
    return axios.get(`${host}/cooperation/rest/v1/candidate/${qzId}/team/list`, { params });
}

export function getRoleList(host, tenantId, params) {
    return axios.get(`${host}/cooperation/rest/v1/candidate/${tenantId}/roles`, { params });
}

export function getRecentContact(host, qzId, params) {
    return axios.get(`${host}/cooperation/rest/v1/candidate/${qzId}/daily_users`, { params })
}

export class DateNode {
    constructor(data, extData) {
        this.data = data;
        this.loading = false;
        this.expand = false;
        this.checked = false;

    }
}